import { buildClient } from '../utils/url';
var shareService = {
    baseUrl: {
        SERVICE: 'share',
        SUSTAINABILITY_REPORTS: 'sustainability_reports',
        CERTIFICATIONS: 'certificates',
        INDUSTRIES: 'industries',
        STORIES: 'stories',
        ORGANIZATION: 'organization',
        SHARE_PAGES: 'share_pages',
    },
    sustainabilityReports: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    certifications: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        SIGNED_PUT_URL: '/signed-put-url',
    },
    industries: {
        GET_MANY: '/',
    },
    stories: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        SIGNED_BANNER_PUT_URL: '/signed-banner-put-url',
        SIGNED_MEDIA_PUT_URL: '/signed-media-put-url',
        SIGNED_MEDIA_GET_URL: '/signed-media-get-url',
    },
    sharePages: {
        GET_MANY: '/',
        GET_ONE: '/:slug',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
};
var shareServiceClient = {
    sustainabilityReports: buildClient(shareService.baseUrl.SUSTAINABILITY_REPORTS, shareService.sustainabilityReports),
    certifications: buildClient(shareService.baseUrl.CERTIFICATIONS, shareService.certifications),
    industries: buildClient(shareService.baseUrl.INDUSTRIES, shareService.industries),
    stories: buildClient(shareService.baseUrl.STORIES, shareService.stories),
    sharePages: buildClient(shareService.baseUrl.SHARE_PAGES, shareService.sharePages),
};
var shareApiGatewayClient = {
    sustainabilityReports: buildClient("".concat(shareService.baseUrl.SERVICE, "/").concat(shareService.baseUrl.SUSTAINABILITY_REPORTS), shareService.sustainabilityReports),
    certifications: buildClient("".concat(shareService.baseUrl.SERVICE, "/").concat(shareService.baseUrl.CERTIFICATIONS), shareService.certifications),
    industries: buildClient("".concat(shareService.baseUrl.SERVICE, "/").concat(shareService.baseUrl.INDUSTRIES), shareService.industries),
    stories: buildClient("".concat(shareService.baseUrl.SERVICE, "/").concat(shareService.baseUrl.STORIES), shareService.stories),
    sharePages: buildClient("".concat(shareService.baseUrl.SERVICE, "/").concat(shareService.baseUrl.SHARE_PAGES), shareService.sharePages),
};
export { shareService, shareServiceClient, shareApiGatewayClient };
//# sourceMappingURL=share-service.js.map